import { PayloadAction } from '@reduxjs/toolkit';

import { VariantsState } from 'editor/src/store/variants/types';

export interface Payload {
  // when omitted, every group is affected
  groupKeys?: string[];
  linked: boolean;
}

// Unlinking is not destructive: every group keeps the designData already held
// in its own variationsInfo, so only further design edits stop propagating.
const linkAllVariantsReducer = (state: VariantsState, action: PayloadAction<Payload>) => {
  const { groupKeys, linked } = action.payload;
  state.variationGroups.forEach((group) => {
    if (groupKeys && !groupKeys.includes(group.key)) {
      return;
    }
    group.linked = linked;
  });
};

export default linkAllVariantsReducer;
